import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Progress } from "reactstrap";
import { withRouter, Link } from "react-router-dom";

import { connect } from "react-redux";
import { getProfile } from "../../store/auth/profile/actions";
import { AvForm, AvField } from "availity-reactstrap-validation";

//Import Components
import LineChart from "./line-chart";
import RevenueChart from "./revenue-chart";
import SalesAnalytics from "./sales-analytics";
import DeviceAnalytics from "./devices";
import Products from "./product";
import LatestTransaction from "./latest-transaction";

//Import Image
import Revenue from "./Revenue";
import { get } from "../../helpers/api_helper";
import Utils from "../Utility";
const { io } = require("socket.io-client");

const Dashboard = ({ user }) => {
  const [data, setData] = useState({ screen: [], dealers: [], moderator: [] });
  const [tenderData, setTenderData] = useState([]);
  const [jobData, setJobData] = useState([]);
  const [newsData, setNewsData] = useState([]);
  const [inquiryData, setInquiryData] = useState([]);
  const [tenderArchiveData, setTenderArchiveData] = useState([]);
  const [jobArchiveData, setJobArchiveData] = useState([]);

  // const [screens, setScreens] = useState([]);
  // const [registeredUser, setRegisteredUser] = useState(0);
  // const [unregisteredUser, setUnregisteredUser] = useState(0);
  // const [ramCounter, setRamCounter] = useState(0);
  // const [time, setTime] = useState(1);
  // const [weekRegisterd, setWeekRegistered] = useState(0);
  // const [weekUnregistered, setWeekUnregistered] = useState(0)
  // const [cities, setCities] = useState([]);
  // const [devices, setDevices] = useState([]);
  // const [products, setProducts] = useState([]);

  // useEffect(() => {
  //   // console.log('props on home ', user);
  //   if (user) {
  //     // getStats();
  //   }
  // }, [user, time]);

  // const getStats = () => {
  //   // console.log('calling get stat');
  //   get("/screen/stat", { token: user?.token })
  //     .then((json) => {
  //       console.log("response from get stat", json);
  //       if (json?.statusCode == 200) {
  //         let appOpen = [],
  //           temp = [];
  //         json?.data?.screens?.map((item) => {
  //           if (item?.for == "splash" || item?.for == "home")
  //             appOpen.push(item);
  //           else temp.push(item);
  //         });
  //         setScreens(temp);
  //         setRegisteredUser(json?.data?.registeredUser);
  //         setUnregisteredUser(json?.data?.unregisteredUser);
  //         setWeekRegistered(json?.data?.weekRegisterd);
  //         setWeekUnregistered(json?.data?.weekUnregistered);
  //         setCities(json?.data?.userByCity);
  //         setDevices(json?.data?.devices);
  //         setProducts(json?.data?.products);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error while getting stat", error);
  //     });

  //   const socket = io(Utils.API_URL + "/ram", {
  //     transports: ["websocket"],
  //     upgrade: false,
  //   });
  //   socket.on("get", (res) => {
  //     console.log("socket on list", res);
  //     if (res?.statusCode == 200) {
  //       // console.log(res?.data)
  //       setRamCounter(res?.counter?.english);
  //     }
  //   });
  //   socket.on("connect", (socket2) => {
  //     console.log("socket connect", socket2);
  //     socket.emit("list", { auth: user?.token });
  //   });
  // };

  useEffect(() => {
    if (user) {
      // getData("/tender", setTenderData, setTenderArchiveData);
      // getData("/job", setJobData, setJobArchiveData);
      // getData("/news", setNewsData);
      // getData("/inquiry", setInquiryData);
      getData();
    }
  }, [user]);

  const getData = () => {
    get("/stat", { token: user?.token })
      .then((json) => {
        if (json?.statusCode === 200) {
          setData(json?.data);
        }
      })
      .catch((error) => {
        console.log(
          `error while getting data from endpoint`,
          error
        );
      });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Row>
          <div className="col-12">
            <div className="page-title-box d-flex align-items-center justify-content-between">
              <h4 className="page-title mb-0 font-size-18">Dashboard</h4>

              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    Welcome to {Utils.projectName} Dashboard
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </Row>
        {
          <Row style={{ justifyContent: "right" }}>
          </Row>
        }
        {
          <Row className="mt-2">
            {/* <Col lg={12}>
              <LineChart data={screens} />
            </Col> */}
          </Row>
        }
        {
          <Row>
            <Col lg={3}>
              <Card style={{ height: "87%", backgroundColor: "#ced4da" }}>
                <CardBody>
                  <Link to="/View-Tender" style={{ color: "black" }}>
                    <div className="d-flex align-items-start">
                      <div className="avatar-sm font-size-20 me-3">
                        <img
                          src={require("../../assets/images/users/tender.png")}
                          style={{ width: 40, height: 40 }}
                        />
                      </div>
                      <div className="flex-1">
                        <div className="font-size-16 mt-2">
                          {" "}
                          <strong>View Tender</strong>
                        </div>
                      </div>
                    </div>

                    <h4 className="mt-4" style={{ textAlign: "center" }}>
                      <strong>{data?.tender}</strong>
                    </h4>
                  </Link>
                </CardBody>
              </Card>
            </Col>
            <Col lg={3}>
              <Card style={{ height: "87%", backgroundColor: "#ced4da" }}>
                <CardBody>
                  <Link to="/View-Job" style={{ color: "black" }}>
                    <div className="d-flex align-items-start">
                      <div className="avatar-sm font-size-20 me-3">
                        <img
                          src={require("../../assets/images/users/job.png")}
                          style={{ width: 40, height: 40 }}
                        />
                      </div>
                      <div className="flex-1">
                        <div className="font-size-16 mt-2">
                          <strong>View Job</strong>
                        </div>
                      </div>
                    </div>
                    <h4 className="mt-4" style={{ textAlign: "center" }}>
                      <strong> {data?.jobs}</strong>
                    </h4>
                  </Link>
                </CardBody>
              </Card>
            </Col>
            <Col lg={3}>
              <Card style={{ height: "87%", backgroundColor: "#ced4da" }}>
                <CardBody>
                  <Link to="/View-news" style={{ color: "black" }}>
                    <div className="d-flex align-items-start">
                      <div className="avatar-sm font-size-20 me-3">
                        <img
                          src={require("../../assets/images/users/news.png")}
                          style={{ width: 40, height: 40 }}
                        />
                      </div>
                      <div className="flex-1">
                        <div className="font-size-16 mt-2">
                          <strong>View News</strong>
                        </div>
                      </div>
                    </div>
                    <h4 className="mt-4" style={{ textAlign: "center" }}>
                      <strong>{data?.news}</strong>
                    </h4>
                  </Link>
                </CardBody>
              </Card>
            </Col>
            <Col lg={3}>
              <Card style={{ height: "87%", backgroundColor: "#ced4da" }}>
                <CardBody>
                  <Link to="/inquiry-master" style={{ color: "black" }}>
                    <div className="d-flex align-items-start">
                      <div className="avatar-sm font-size-20 me-3">
                        <img
                          src={require("../../assets/images/users/inquiry.png")}
                          style={{ width: 40, height: 40 }}
                        />
                      </div>
                      <div className="flex-1">
                        <div className="font-size-16 mt-2">
                          <strong>Inquiry Master</strong>
                        </div>
                      </div>
                    </div>
                    <h4 className="mt-4" style={{ textAlign: "center" }}>
                      {" "}
                      <strong>{data?.inquiry}</strong>
                    </h4>
                  </Link>
                </CardBody>
              </Card>
            </Col>
            <Col lg={3}>
              <Card style={{ height: "87%", backgroundColor: "#ced4da" }}>
                <CardBody>
                  <Link to="/archive-tender" style={{ color: "black" }}>
                    <div className="d-flex align-items-start">
                      <div className="avatar-sm font-size-20 me-3">
                        <img
                          src={require("../../assets/images/users/tender-archived.png")}
                          style={{ width: 40, height: 40 }}
                        />
                      </div>
                      <div className="flex-1">
                        <div className="font-size-16 mt-2">
                          {" "}
                          <strong>Tender Archived</strong>
                        </div>
                      </div>
                    </div>
                    <h4 className="mt-4" style={{ textAlign: "center" }}>
                      {" "}
                      <strong>{data?.tenderA}</strong>
                    </h4>
                  </Link>
                </CardBody>
              </Card>
            </Col>
            <Col lg={3}>
              <Card style={{ height: "87%", backgroundColor: "#ced4da" }}>
                <CardBody>
                  <Link to="/archive-job" style={{ color: "black" }}>
                    <div className="d-flex align-items-start">
                      <div className="avatar-sm font-size-20 me-3">
                        <img
                          src={require("../../assets/images/users/job-archived.png")}
                          style={{ width: 40, height: 40 }}
                        />
                      </div>
                      <div className="flex-1">
                        <div className="font-size-16 mt-2">
                          {" "}
                          <strong>Job Archived</strong>
                        </div>
                      </div>
                    </div>
                    <h4 className="mt-4" style={{ textAlign: "center" }}>
                      {" "}
                      <strong>{data?.jobsA}</strong>
                    </h4>
                  </Link>
                </CardBody>
              </Card>
            </Col>
          </Row>
        }
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  getProfile: PropTypes.func,
};

const mapStateToProps = (state) => {
  // console.log('state at dashboard', state);
  const { user } = state.Profile;
  return { user };
};

export default withRouter(connect(mapStateToProps, { getProfile })(Dashboard));
